<template>
<div class="collabsable-section">
    <!--Header-->
    <div class="section-title clickable-header" @click="toggleExpanded()">
        <div class="markups-stamps"></div>
        <div style="flex-grow: 1; font-size: 17px">Markups Stamps</div>
        <div style="color: gray" class="expand-collapse-ico fas" :class="!isExpanded ? 'fa-caret-down' : 'fa-caret-up'"></div>
    </div>
    <!--Expander-->
    <div v-if="isExpanded" class="expanded-section">
        <!--Folders List-->
        <AdminStampsFolder :key="folder.id" :folder="folder"></AdminStampsFolder>
        <!--Confirmation Messages-->
        <div class="info-section" style="align-items: center">
            <input type="file" webkitdirectory multiple style="display: none" id="browsePointCloudFile" @change="onPointCloudFileChanged($event)" />
            <progress style="width: 50%; height: 20px" v-if="isUploadingPointCloud" min="0" :max="maxProgress" step="1" :value="progress"></progress>
            <div v-if="isUploadingPointCloud">
                {{ progress }}/{{ maxProgress }} Files
                {{ isDeleting ? "Deleted" : "Uploaded" }}
            </div>
            <div style="display: flex; width: 100%; justify-content: center">
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { toggleExpandComponent } from "../../../../scripts/js/forgeviewer";
import { ForgeMarkupStamp } from "../../../../scripts/js/forgeModels";
import { getAllMarkupStamps, saveMarkupStamp } from "../../../../utils/mongoUtils";
export default {
    name: "AdminStamps",
    components: {
        'AdminStampsFolder': () => import('./adminStampsFolder.vue'),
    },
    emits: ["update_category", "delete_category"],
    props: ["assetid"],
    data() {
        return {
            isExpanded: false,
            isUploadingPointCloud: false,
            progress: 0,
            maxProgress: 100,
            isDeleting: false,
            searchText: "",
            folderPath: "",
            itemsTree: [],
            folder:[],
        };
    },
    async mounted() {
        var allMarkupStamps = await getAllMarkupStamps()
        this.itemsTree = this.getStampsTree(allMarkupStamps);
        this.folders = this.itemsTree.folders;
        this.folder = {
            name: 'Markups Stamps',
            stamps: this.itemsTree.stamps,
            folders:this.folders,
            path: '',
            id: this.$store.state.forgeService.newGuid(),
        };
    },
    methods: {
        addNewStamp(folder) {
            var _this = this;
            this.$store.dispatch({
                type: "prompt_Forge_Extended",
                title: "Add new Stamp",
                callback: (inputs) => {
                    var name = inputs[0].trim();
                    var svgText = inputs[1];
                    var stamp = new ForgeMarkupStamp();
                    stamp.name = name;
                    stamp.createdOn = new Date().toDateString();
                    stamp.userId = _this.$store.state.username;
                    stamp.createdBy = _this.$store.state.username;
                    stamp.svgText = svgText;
                    stamp.folderPath = _this.folderPath;
                    saveMarkupStamp(stamp);
                    _this.getCurrentNode().stamps.push(stamp);
                },
                input: {
                    inputName: "Name",
                    inputValue: "",
                },
                extendedInput: {
                    inputName: "SVG Text",
                    inputValue: "",
                },
            });
        },
        getStampsTree(stamps) {
            let tree = {
                name: "",
                stamps: [],
                folders: [],
            };
            for (let stamp of stamps) {
                if (!stamp.folderPath) tree.stamps.push(stamp);
                else {
                    let folders = stamp.folderPath.split("/");
                    let folderToAddInto = tree;
                    let path = "";
                    for (let name of folders) {
                        path += path ? "/" + name : name;
                        let folder = folderToAddInto.folders.find((o) => o.name == name);
                        if (!folder) {
                            folder = {
                                name: name,
                                stamps: [],
                                folders: [],
                                path: path,
                                id: this.$store.state.forgeService.newGuid(),
                            };
                            folderToAddInto.folders.push(folder);
                        }
                        folderToAddInto = folder;
                    }
                    folderToAddInto.stamps.push(stamp);
                }
            }
            return tree;
        },
        getCurrentNode() {
            let node = this.itemsTree;
            if (!this.folderPath) return node;
            let folders = this.folderPath.split("/");
            for (let folder of folders) {
                node = node.folders.find((o) => o.name == folder);
            }
            return node;
        },
        toggleExpandedFolder(path) {
            var _this = this;
            if (_this.folderPath === path) {
                //Navigate up
                var lastSlash = path.lastIndexOf("/");
                var parentPath = path.slice(0, lastSlash);
                _this.folderPath = parentPath;
            } else {
                _this.folderPath = path;
            }
        },
        toggleExpanded() {
            toggleExpandComponent(this);
        },
    },
};
</script>

<style>
.markups-stamps {
    background-size: cover;
    background-image: url(../../../../images/markupTools/stamp.svg);
    width: 23px;
    height: 23px;
    margin-right: 10px;
}
</style>
